import React from 'react';

export const RotateImage = () => (
    <>
        <path d='M12.8,0H0.3v18.4h5.3v5.3H24V11.2H12.8V0z M22.7,22.4H6.9v-9.9h15.8V22.4z M1.6,1.3h9.9v9.9H5.6v5.9h-4V1.3z' />
        <path d='M16.1,1.3v1.3c0.2,0,0.5,0,0.7,0.1C19.2,3,21,4.8,21.3,7.2c0,0.2,0.1,0.5,0.1,0.7H20l2,2l2-2h-1.3 C22.7,4.3,19.7,1.3,16.1,1.3L16.1,1.3z' />
        <path d='M23,8l-1.4,0c0-0.2,0-0.5-0.1-0.7c-0.3-2.3-2.2-4.1-4.7-4.4c-0.2,0-0.5-0.1-0.7-0.1l0,1.3l-2.1-1.9l2.1-1.9l0,1.3 C20,1.6,23,4.5,23,8L23,8z' />
    </>
);